'use client';
/**
 * Dependencies
 */
import React from 'react';
import ShoppingModule from '~/app/components/front-page-redesign/shopping-module';
import CampaignModule from '~/app/components/front-page-redesign/campaign-module/campaign-module';
import SocialModule from '~/app/components/front-page-redesign/social-module/social-module';
import { Box, CenteredContainer, Text } from '@nerdwallet/currency';
import styles from './front-page-container.module.scss';
import QuizModule from '~/app/components/front-page-redesign/quiz';
import AppDownloads from '~/app/components/front-page-redesign/app-download-module';
import Articles from '~/app/components/front-page-redesign/articles';
import { NewsArticlesQuery } from '~/generated-graphql/generated-types';
import { TreasuryRates } from '~/app/queries/types';

interface Props {
  articlesData?: NewsArticlesQuery | undefined;
  socialVideos?: string[] | undefined;
  treasuryRates?: TreasuryRates;
}

const FrontPageContainer = ({
  articlesData,
  socialVideos,
  treasuryRates,
}: Props) => {
  return (
    <Box className={styles.mainWrapper}>
      <CenteredContainer>
        <div className={styles.heading}>
          <div className={styles.headingTitle}>
            <Text component="h1" bold>
              <span className={styles.titleSize}>
                The Nerds can find your next financial product in minutes
              </span>
            </Text>
          </div>
        </div>
        <ShoppingModule />
      </CenteredContainer>
      <QuizModule />
      <Articles articlesData={articlesData} alternativeVersion />
      <CampaignModule
        pageType="CASH_ACCOUNT_AD"
        showCampaignModule
        showBestOfAwards={false}
        treasuryRates={treasuryRates}
      />
      <SocialModule socialVideos={socialVideos} />
      <AppDownloads
        backgroundColor="#00482F"
        negativeTopMarginValue={53}
        treasuryRates={treasuryRates}
      />
    </Box>
  );
};

export default FrontPageContainer;
